import env from "react-dotenv";
// import { jwtDecode } from 'jwt-decode';

export const setTrackingUserId = () => {
    if (env.ENVIRONMENT === 'production') {
        // const decoded = localStorage.getItem("auth") && jwtDecode(localStorage.getItem("auth"));
        // mixpanel.identify(decoded?._id || 'GUEST');
    }
}
